import { css } from "@emotion/react";
import type { ExactTheme } from "src/lib/emotion/theme.ts";
import { EXONN_HUB_ORDER_PREVIEW_MODAL_OVERLAY_Z_INDEX } from "src/admin/modules/b2b-gate-order/components/ExonnHub/ExonnHub.constants.ts";

export const root =
  ({ isFullscreen }: { isFullscreen: boolean }) =>
  (theme: ExactTheme) => css`
    position: relative;
    display: flex;
    background-color: ${theme.colorsV2.grey[50]};
    width: 100%;
    height: 100%;
  `;

export const orderPreviewOverlay = css({
  backgroundColor: "black",
  opacity: "0.3",
  zIndex: EXONN_HUB_ORDER_PREVIEW_MODAL_OVERLAY_Z_INDEX,
});

export const outer = ({ isFullscreen }: { isFullscreen: boolean }) => css`
  border-radius: 6px;
  overflow: hidden;
  width: calc(100dvw - ${isFullscreen ? "40px" : "240px"});
  height: calc(100dvh - ${isFullscreen ? "40px" : "40px"});
  position: relative;
`;
